import React, { useState, useEffect } from 'react';
import { getProfiles } from '../../services/api';

function ProfileManager() {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadProfiles();
  }, []);

  const loadProfiles = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await getProfiles();
      if (response.data.success) {
        setProfiles(response.data.profiles);
      } else {
        const errorMsg = typeof response.data.error === 'object' 
          ? response.data.error.message || 'Failed to load profiles'
          : response.data.error || 'Failed to load profiles';
        setError(errorMsg);
      }
    } catch (err) {
      const errorMsg = typeof err.response?.data?.error === 'object'
        ? err.response.data.error.message || 'Failed to load profiles'
        : err.response?.data?.error || err.message || 'Failed to load profiles';
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  const isExpired = (expirationDate) => {
    return new Date(expirationDate) < new Date();
  };

  if (loading) {
    return (
      <div className="loading-inline">
        <div className="spinner"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="alert alert-error">
        <span className="alert-icon">⚠️</span>
        <span>{error}</span>
      </div>
    );
  }

  return (
    <div>
      <p className="text-secondary" style={{ marginBottom: '20px' }}>
        Provisioning profiles allow you to install and test your app on devices.
      </p>

      {profiles.length === 0 ? (
        <div className="empty-state">
          <div className="empty-state-icon">📋</div>
          <p className="empty-state-title">No provisioning profiles found</p>
        </div>
      ) : (
        <div style={{ overflowX: 'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Type</th>
                <th>Platform</th>
                <th>Expiration</th>
                <th>State</th>
              </tr>
            </thead>
            <tbody>
              {profiles.map(profile => {
                const expired = isExpired(profile.attributes?.expirationDate || profile.expirationDate);
                const isActive = (profile.attributes?.profileState || profile.profileState) === 'ACTIVE';
                
                return (
                  <tr key={profile.id}>
                    <td>{profile.attributes?.name || profile.name || 'N/A'}</td>
                    <td className="mono" style={{ fontSize: '13px' }}>
                      {profile.attributes?.profileType || profile.profileType || 'N/A'}
                    </td>
                    <td>{profile.attributes?.platform || profile.platform || 'N/A'}</td>
                    <td>
                      <span className={expired ? 'text-error' : ''}>
                        {new Date(profile.attributes?.expirationDate || profile.expirationDate).toLocaleDateString()}
                      </span>
                    </td>
                    <td>
                      <span className={`badge ${isActive ? 'badge-success' : 'badge-error'}`}>
                        {profile.attributes?.profileState || profile.profileState || 'UNKNOWN'}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}

      <div className="alert alert-info" style={{ marginTop: '20px' }}>
        <span className="alert-icon">💡</span>
        <span>
          <strong>Tip:</strong> Use the CLI tool to create, download, and manage provisioning profiles.
        </span>
      </div>
    </div>
  );
}

export default ProfileManager;
